export const FELICITY_CHAT_URL = process.env.REACT_APP_FELICITY_URL || '';

export const FELICITY_VOICE_URL = FELICITY_CHAT_URL
    ? FELICITY_CHAT_URL.replace(/\/api\/felicity\/chat.*$/, '/api/felicity/voice/token')
    : '';

export const FELICITY_WELCOME = "Hello, I'm Felicity. How can I help?";

export const FELICITY_NOT_CONNECTED =
    'I am not connected yet. The help centre has everything on this page, and its search box finds it.';

export const FELICITY_FAB_CLEARANCE = 180;

// AD-2660: what the panel says when Felicity's reply carries an outline but no words, or nothing at all.
export const FELICITY_SHOWN = 'It is lit up on your screen now.';
export const FELICITY_NO_WORDS = 'I could not answer that just now. Please ask again.';
